import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useUserActions} from "../service/user.actions";
import {WarningAmberRounded} from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';
import {setDialog} from "../../../util/state/globalAction";
import {dialogTypes} from "../../../util/state/globalVariables";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

const NotAuthorizedDialog = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {dispatchGlobalData} = useContext(GlobalContext);
    const handleClose = () => {
        dispatchGlobalData({
            type: setDialog,
            payload: {
                dialog: dialogTypes.none
            }
        });
        navigate("/");
    };

    return (
        <Dialog
            open={true}
            onClose={() => {}}
            aria-labelledby="responsive-dialog-title"
            disableEscapeKeyDown={true}
        >
            <DialogTitle id="responsive-dialog-title" sx={{display: 'flex', justifyContent: 'center'}}>
                {t('error.notAuthorized')}
                <WarningAmberRounded color={'error'}/>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('error.notAuthorizedMessage')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {t('info.ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NotAuthorizedDialog;